import '../styles/About.css';
import profile_img from '../assets/transparent2.PNG';
import AboutSkills from './AboutSkills';

export default function About() {
    return (
        <div className='about'>
            <div className='about__container'>
                <div className='about__img'>
                    <img src={profile_img} alt='profile'/>
                </div>
                <div className='about__text'>
                    <h1>Web Full-Stack Engineer</h1>
                    <h2>
                        Helping companies create innovative and efficient web solutions that enhance user experiences and drive business success.
                    </h2>
                </div>
            </div>
            <div className='about__skills'>
                <AboutSkills />
            </div>
        </div>
    );
}